import React from 'react';
import {CSSTransition} from "react-transition-group";
import { makeStyles } from '@material-ui/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import {Trophy,Tools,Briefcase,Application,Account,School,Instagram,Gmail,LinkedinBox,GithubCircle,CloudDownload} from 'mdi-material-ui';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';

//components
import Skills from './components/Skills';
import Work from './components/Work';
import Honors from './components/Honors';
import Projects from './components/Projects';
import About from './components/About';

import './App.css';
import Education from './components/Education';

const useStyles = makeStyles(theme => ({
    container:{
        [theme.breakpoints.up('lg')]: {
            maxWidth: '1140px',
            paddingRight:15,
            paddingLeft:15,
        },
        [theme.breakpoints.between('md','lg')]:{
            maxWidth: '900px',
            paddingRight:15,
            paddingLeft:15,
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
            paddingRight:0,
            paddingLeft:0,
        },
        
        height:'100%',
        width:"100%",
        
        marginLeft:'auto',
        marginRight:'auto',
        flex: '1 1 auto'
    },
    root:{
        display:'flex',
        flexWrap:'wrap',
        marginRight:'-15px',
        marginLeft:'-15px',
        overflow:'hidden',
        height:"100%",
    },
    left: {
        maxWidth:'calc(50% - 30px)',
        zIndex:1,padding:'0 !important',
        flex:'0 0 50%',
        position:'relative',
        width:'100%',
        minHeight:1,
        background:'#090000',
        color:'white',
        margin:"50px 0"
    },
    right:{
        maxWidth:'calc(50% + 30px)',
        padding:'0 !important',
        flex:'auto',
        transition:'0.5s all',
        zIndex:0,
        position:'relative',
        width:'100%',
        background:'#000000',
        minHeight:1,
        margin:"50px 0",
        color:'white',
        height:'90%',
        display:'flex',
        alignItems:'center',
        justifyContent:'center'
    },
    leftContent:{
        display:'flex',
        height:'100%',
        width:'100%',
        background:'#1b1c1c'
    },
    rightContent:{
        background:"#1c1e1f",
        margin:'50px 0',
        paddingBottom:20,
        overflow:'auto',
        height:"90%",
        width:'100%'
    },
    navContainer:{
        display:"flex",
        alignItems:"center",
        [theme.breakpoints.up('md')]: {
            height:'auto'
        },
        [theme.breakpoints.down('md')]: {
           height:'100%'
        },
    },
    nav:{
        background:'#171a1c !important',
        [theme.breakpoints.up('md')]: {
            height:'100%'
        },
        [theme.breakpoints.down('md')]: {
           height:'100%'
        },
        display:"flex",
        alignItems:"center"
    },
    navButton:{
        color:'#a8a8a8',
        paddingRight:0,
        paddingLeft:0,
        minWidth:70
    }
}));


function render(view,info=false,xl=false){
    switch(view){
        case 0:
            return (info?(<div>
                <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                    <div style={{width:"100%"}}>
                        <div style={{display:"flex",justifyContent:"center",alignContent:"center"}}>
                            <Avatar alt="Remy Sharp" src="me.jpeg" style={{width:(xl?200:150),height:(xl?200:150)}} />
                        </div>
                        <Typography component="div" variant={xl?"h2":"h3"}>
                            <Box  textAlign="center" m={2} style={{marginTop:xl?70:40}}>
                                Amirhossein Hassankhani
                            </Box>
                        </Typography>
                        <div style={{margin:xl?"40px auto":"20px auto",display:"flex",justifyContent:"center",alignItems:"center"}}>
                            <div>
                                <a href="https://github.com/amirhossein-hkh" rel="noopener noreferrer" target="_blank"><GithubCircle color="primary" style={{fontSize:xl?40:35,margin:10}}/></a>
                                <a href="mailto:amirhossein.hassankhani1997@gmail.com" target="_top"><Gmail color="primary" style={{fontSize:xl?40:35,margin:10}} /></a>
                                <a href="https://linkednd.com/in/amirhosseinhassankhani-020a5a167" rel="noopener noreferrer" target="_blank"><LinkedinBox color="primary" style={{fontSize:xl?40:35,margin:10}} /></a>
                                <a href="https://instagram.com/amirhoseinhkh76" rel="noopener noreferrer" target="_blank"><Instagram color="primary" style={{fontSize:xl?40:35,margin:10}} /></a>
                                
                            </div>
                        </div>
                        <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                            <Button color="primary" variant="contained" component="a" href="cv.pdf" rel="noopener noreferrer" target="_blank">
                                <CloudDownload color="secondary" style={{marginRight:10}} />
                                Download CV
                            </Button>
                        </div>
                    </div>
                </div>
                <About />
            </div>):<About />)
        case 1:
            return <Education />
        case 2:
            return <Projects />
        case 3:
            return <Honors />
        case 4:
            return <Work />
        case 5:
            return <Skills />
        default:
            return <div>not defined yet</div>
    }

}

function App(props){
    const classes = useStyles();
    const [state, setState] = React.useState({
        flip: false,
        view:0,
        tempView:0
    });
    let xl = props.width === "xl";
    let lg = props.width === "lg";
    // let md = props.width === "md";
    // let sm = props.width === "sm";
    // let xs = props.width === "xs";

    
    return (
        <div className={classes.container}>
            {(xl||lg)?(

                <div className={classes.root}>
                    <div className={classes.left}>
                        <div className={classes.leftContent}>
                            <div className={classes.navContainer}>
                                <div className={classes.nav}>
                                    <BottomNavigation
                                        value={state.tempView}
                                        onChange={(event, newValue) => {
                                            setState({...state,tempView:newValue,flip:!state.flip});
                                        }}
                                        style={{flexDirection:"column",height:"auto",background:'#171a1c',padding:"10px 0"}}
                                        showLabels
                                        >
                                        <BottomNavigationAction classes={{root:classes.navButton}} label="About Me" icon={<Account />} />
                                        <BottomNavigationAction classes={{root:classes.navButton}} label="Education" icon={<School />} />
                                        <BottomNavigationAction classes={{root:classes.navButton}} label="Projects" icon={<Application />} />
                                        <BottomNavigationAction classes={{root:classes.navButton}} label="Honors" icon={<Trophy />} />
                                        <BottomNavigationAction classes={{root:classes.navButton}} label="Work" icon={<Briefcase />} />
                                        <BottomNavigationAction classes={{root:classes.navButton}} label="Skills" icon={<Tools />} />
                                    </BottomNavigation>
                                </div>
                            </div>
                            <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                                <div style={{width:"100%"}}>
                                    <div style={{display:"flex",justifyContent:"center",alignContent:"center"}}>
                                        <Avatar alt="Remy Sharp" src="me.jpeg" style={{width:(xl?200:150),height:(xl?200:150)}} />
                                    </div>
                                    <Typography component="div" variant={xl?"h2":"h3"}>
                                        <Box  textAlign="center" m={2} style={{marginTop:xl?70:40}}>
                                            Amirhossein Hassankhani
                                        </Box>
                                    </Typography>
                                    <div style={{margin:xl?"40px auto":"20px auto",display:"flex",justifyContent:"center",alignItems:"center"}}>
                                        <div>
                                            <a href="https://github.com/amirhossein-hkh" rel="noopener noreferrer" target="_blank"><GithubCircle color="primary" style={{fontSize:xl?40:35,margin:10}}/></a>
                                            <a href="mailto:amirhossein.hassankhani1997@gmail.com" target="_top"><Gmail color="primary" style={{fontSize:xl?40:35,margin:10}} /></a>
                                            <a href="https://linkednd.com/in/amirhosseinhassankhani-020a5a167" rel="noopener noreferrer" target="_blank"><LinkedinBox color="primary" style={{fontSize:xl?40:35,margin:10}} /></a>
                                            <a href="https://instagram.com/amirhoseinhkh76" rel="noopener noreferrer" target="_blank"><Instagram color="primary" style={{fontSize:xl?40:35,margin:10}} /></a>
                                            
                                        </div>
                                    </div>
                                    <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                                        <Button color="primary" variant="contained" component="a" href="cv.pdf" rel="noopener noreferrer" target="_blank">
                                            <CloudDownload color="secondary" style={{marginRight:10}} />
                                            Download CV
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <CSSTransition in={state.flip} timeout={500} classNames="anim" onEnter={()=>setTimeout(()=>{setState({...state,view:state.tempView})},500)} onExit={()=>setTimeout(()=>{setState({...state,view:state.tempView})},500)}>
                        <div className={classes.right}>
                            <div className={classes.rightContent}>
                                {render(state.view)}
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            ):(
                <div style={{display:"flex",height:"100%",color:"white",background:"#1c1e1f"}}>

                    <div className={classes.navContainer}>
                        <div className={classes.nav}>
                            <BottomNavigation
                                value={state.tempView}
                                onChange={(event, newValue) => {
                                    setState({...state,tempView:newValue,flip:!state.flip});
                                }}
                                style={{flexDirection:"column",height:"auto",background:'#171a1c',padding:"10px 0"}}
                                showLabels
                                >
                                <BottomNavigationAction classes={{root:classes.navButton}} label="About Me" icon={<Account />} />
                                <BottomNavigationAction classes={{root:classes.navButton}} label="Education" icon={<School />} />
                                <BottomNavigationAction classes={{root:classes.navButton}} label="Projects" icon={<Application />} />
                                <BottomNavigationAction classes={{root:classes.navButton}} label="Honors" icon={<Trophy />} />
                                <BottomNavigationAction classes={{root:classes.navButton}} label="Work" icon={<Briefcase />} />
                                <BottomNavigationAction classes={{root:classes.navButton}} label="Skills" icon={<Tools />} />
                            </BottomNavigation>
                        </div>
                    </div>
                    <div style={{height:"100%",overflow:'auto'}}>
                        {render(((lg||xl)?state.view:state.tempView),true,xl)}
                    </div>
                    
                </div>
            )}
        </div>

    )
}

export default withWidth()(App);